import type { ApexOptions } from 'apexcharts';

export const chartTheme = {
  mode: 'dark' as const,
  palette: 'palette1',
};

export const energyColors = {
  solar: '#8FB560',      // Hollywood green (primary)
  battery: '#3b82f6',    // Blue
  grid: '#d97706',       // Amber/orange
  generator: '#6b7280',  // Gray
  accent: '#8FB560',
  warning: '#eab308',
  danger: '#ef4444',
};

export const defaultChartOptions: ApexOptions = {
  chart: {
    background: 'transparent',
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: 'inherit',
  },
  theme: chartTheme,
  grid: {
    borderColor: 'rgba(255,255,255,0.1)',
    strokeDashArray: 3,
  },
  tooltip: {
    theme: 'dark',
  },
  dataLabels: {
    enabled: false,
  },
};
